import { Link } from "@design-system/components";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@design-system/components/ui";
import { footerLinks } from "@design-system/data";
import { trans } from "@mongez/localization";

export function FooterAccordion() {
  return (
    <div className="py-6 md:hidden">
      <Accordion
        type="single"
        collapsible
        defaultValue={String(footerLinks[0].id)}
      >
        {footerLinks.map((link) => (
          <AccordionItem
            key={link.id}
            value={String(link.id)}
            className="border-0 py-2"
          >
            <AccordionTrigger className="font-medium">
              {trans(link.title)}
            </AccordionTrigger>
            <AccordionContent className="flex flex-col gap-1">
              {link.children.map((child, index) => (
                <Link
                  key={index}
                  to={child.href}
                  className="py-2 capitalize text-white text-opacity-70"
                >
                  {trans(child.title)}
                </Link>
              ))}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
